/**
 * El idioma: tipo, constantes y validación. SIN `'use client'`.
 *
 * ═══════════════════════════════════════════════════════════════════════════
 * POR QUE ESTE FICHERO EXISTE
 * ═══════════════════════════════════════════════════════════════════════════
 *
 * Esto vivía en `context.tsx`, que empieza por `'use client'`. Funcionaba
 * mientras solo lo usaba el navegador — hasta que el layout raíz, que corre en
 * el SERVIDOR, necesitó leer la cookie del idioma antes del primer pintado.
 *
 * Next lo rechaza en tiempo de ejecución con un error claro:
 *
 *   Attempted to call esIdioma() from the server but esIdioma is on the client.
 *
 * Y `tsc` NO lo caza: los tipos cuadran, la frontera cliente/servidor no es una
 * regla de tipos. Es la clase de fallo que solo aparece al abrir la página.
 *
 * Aquí no hay directiva, así que las dos mitades pueden importarlo: el layout
 * del servidor para resolver el idioma, y el proveedor del cliente para
 * guardarlo. Una sola definición, y no dos listas de idiomas que se separan en
 * cuanto se añada el cuarto.
 */

export type Language = 'en' | 'es' | 'zh';

export const IDIOMAS: readonly Language[] = ['es', 'en', 'zh'];

/**
 * ESPAÑOL por defecto.
 *
 * Antes era inglés. Esto lo usa un operador logístico colombiano: quien abre la
 * aplicación por primera vez —y quien entra desde un ordenador del muelle que
 * nadie ha configurado— lo quiere en español desde el primer minuto.
 */
export const IDIOMA_POR_DEFECTO: Language = 'es';

/**
 * La cookie es una PREFERENCIA DE PANTALLA: sin sesión y sin dato personal.
 *
 * Una cookie y no la sesión, por tres motivos: vale en el login y en el panel
 * de X-Cargo —donde todavía no hay empresa activa—, la puede leer el servidor
 * antes de pintar, y sobrevive al cierre de sesión, que es lo que quiere quien
 * comparte el ordenador del muelle.
 */
export const COOKIE_IDIOMA = 'pacio_lang';

export function esIdioma(valor: unknown): valor is Language {
  return typeof valor === 'string' && (IDIOMAS as readonly string[]).includes(valor);
}
